import {sprintf} from "@wordpress/i18n";

export const mapLineItems = (items) => {
    return items.map(item => {
        // Map generic type to Google Pay type
        let type = 'LINE_ITEM';
        if (item.type === 'tax') {
            type = 'TAX';
        } else {
            type = 'SUBTOTAL';
        }

        return {
            label: item.label,
            type: type,
            price: item.amount
        };
    });
};

export const mapShippingOptions = (options, currency) => {
    return options.map(option => ({
        id: option.id,
        label: sprintf('%s: %s %s', option.label, option.amount, currency),
        description: option.description || ''
    }));
}

export const extractAddress = (data) => {
    if (!data) {
        return {};
    }

    const address = {};
    address.first_name = data.name?.split(' ')[0] || '';
    address.last_name = data.name?.split(' ').slice(1).join(' ') || '';
    address.address_1 = data.address1 || '';
    address.address_2 = data.address2 || '';
    address.city = data.locality || '';
    address.state = data.administrativeArea || '';
    address.postcode = data.postalCode || '';
    address.country = data.countryCode || '';

    if (data.phoneNumber) {
        address.phone = data.phoneNumber;
    }

    return address;
}